class Shape {
    constructor(shape, text, index) {
        this.parent = null;
        this.prev_item = null;
        this.next_item = null;
        this.identifier = null;

        this.direction = null;
        this.style = null;

        this.index = index;
        this.text = text;
        this.shape = shape;
        this.branches = {};
        this.current_branch = null;
    }

    set_prev_item(prev_item) {
        this.prev_item = prev_item;
        prev_item.next_item = this;
    }

    get_next_item(next_item) {
        next_item = this.next_item;
        if (!next_item) {
            const parent = this.parent;
            if (parent)
                return parent.get_next_item();
        }

        return next_item;
    }

    get_id() {
        return "id" + this.identifier;
    }

    add_branch(name) {
        this.branches[name] = [];
        this.current_branch = this.branches[name];
    }

    add_child(child) {
        this.current_branch.push(child);
    }

    process() {
        let prev_item;
        let shape;
        let shapes;
        let j = 0;
        const branches = this.branches;
        let branch;
        for (branch in branches) {
            shapes = branches[branch];
            j = 0;
            for (shape of shapes) {
                shape.parent = this;
                if (j > 0) {
                    prev_item = shapes[j - 1];
                    shape.set_prev_item(prev_item);
                }
                shape.process();
                j += 1;
            }
        }
    }

    json() {
        const branches = {};
        const json = {
            "shape": this.shape,
            "text": this.text,
            "index": this.index,
            "direction": this.direction,
            "branches": branches,
            "style": this.style
        };

        const this_branches = this.branches;
        let branch;
        let shape;
        for (branch in this_branches) {
            branches[branch] = [];
            let current = branches[branch];
            for (shape of this_branches[branch]) {
                current.push(shape.json());
            }
        }
        return json;
    }

    print_id(generator) {
        generator.generate_shape(this);

        const branches = this.branches;
        let branch, shape;
        for (branch in branches) {
            for (shape of branches[branch]) {
                shape.print_id(generator);
            }
        }
    }

    print_connection(generator) {
        generator.generate_connection(this);

        const branches = this.branches;
        let branch, shape;
        for (branch in branches) {
            for (shape of branches[branch]) {
                shape.print_connection(generator);
            }
        }
    }
}


export default Shape;
